import { FC, useState } from 'react'

type TextareaInputProps = {
  label: string
  value: string
  onChange: (name: string, value: string) => void
  id: string
  className?: string
  validate?: (value: string) => boolean
  isValid?: boolean
  errorMessage?: string
}

const TextareaInput: FC<TextareaInputProps> = ({
  label,
  onChange,
  id,
  value,
  className = '',
  isValid = true,
  errorMessage = 'This field is required'
}) => {
  const inputBorder = isValid ? 'border-gray-200' : 'border-primary-default'
  const labelColor = isValid ? '' : 'text-primary-default'
  const errorClass = isValid ? 'hidden' : 'text-primary-default'
  return (
    <div className={`w-full px-3 mb-6 md:mb-0 ${className}`}>
      <label
        htmlFor={id}
        className={`block tracking-wide text-lg mb-2 font-display font-semibold ${labelColor}`}
      >
        {label}
      </label>
      <textarea
        name={id}
        required
        className={`no-resize appearance-none block w-full bg-gray-200 text-gray-700 border ${inputBorder} rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-gray-500 text-md  h-48 resize-none`}
        id={id}
        value={value}
        onChange={(e) => {
          e.preventDefault()
          const { name, value } = e.target
          onChange(name, value)
        }}
      />
      <div className={errorClass}>{errorMessage}</div>
    </div>
  )
}

export default TextareaInput
